import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { ALIANZA_BANNER_TIPO } from '../../data/perfil-alianza.content';
import {
  mapAlianzasDesdeBanners,
  normalizeAlianzaBannerRows,
} from './perfil-alianza.mapper';
import {
  AlianzaBannersResponse,
  AlianzaEstrategica,
} from './perfil-alianza.model';

/**
 * HU 8338 B.1 — alianzas `Estrategico` ACTIVO.
 * Reusa `GET banner/bannersActivos/{tipo}` (orden ASC).
 */
@Injectable({ providedIn: 'root' })
export class PerfilAlianzaService {
  constructor(private readonly bancoldex: BancoldexService) {}

  loadActivas(): Observable<AlianzaEstrategica[]> {
    return this.bancoldex.getArchivosBannerActivos(ALIANZA_BANNER_TIPO).pipe(
      map((raw) =>
        mapAlianzasDesdeBanners(
          normalizeAlianzaBannerRows(raw as AlianzaBannersResponse)
        )
      ),
      catchError(() => of([]))
    );
  }
}
